import React from 'react';
import {bool, func, object} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {basicForm} from 'utils/helpers';
import config from './renameStepFormConfig';

const RenameStepForm = basicForm(config);

const RenameStepModal = props => (
  <BasicModal
    header='Change step name'
    specialType='db-steps-modal primary-modal'
    dimmer='inverted'
    modalSize='small'
    actions={[
      {
        label: 'Cancel',
        action: props.handleClose,
        isDisabled: false,
        displayType: 'menu-item'
      },
      {
        label: 'Save',
        action: props.submit,
        isDisabled: props.hasErrors || !props.formData.label,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.handleClose}>
    <RenameStepForm
      onValueChanged={props.onValueChanged}
      onValidationError={props.onValidationError}
      errors={props.errors}
      data={props.formData} />
  </BasicModal>
);

RenameStepModal.propTypes = {
  formData: object.isRequired,
  submit: func.isRequired,
  onValueChanged: func.isRequired,
  onValidationError: func,
  hasErrors: bool,
  handleClose: func.isRequired,
  modalOpen: bool.isRequired
};

export default RenameStepModal;



// WEBPACK FOOTER //
// ./public/components/steps/RenameStep/RenameStepModal.jsx